module.exports = __webpack_public_path__ + "static/media/worn-by-the-best-poster.a76422df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/worn-by-the-best-poster.jpg
// module id = 3559
// module chunks = 0